module.exports = __webpack_public_path__ + "img/3.5e322036.svg";